import React, { Component } from 'react';
import {getLenovoIdInfo, getUserType, getQueryVariable} from "../../requist";
import WEMenuJson from '../../data/menu/WECustomer.json';
import EMMenuJson from '../../data/menu/EMCustomer.json';
import AllMenuJson from '../../data/menu/ALLCustomer.json';
import ApproverJson from '../../data/menu/ApproverCustomer.json';
import {message, Spin} from 'antd';
const approverCustomerList = [
    "doa@mkcl.de",
    // "t1d_admin_dk_authorized@dummy.com"
 ]
class LenovoIdLogin extends Component{
    getMenuList() {
        //外部用户
        //  1. 调用接口查询当前外部用户的角色 WE\EM 
        //  2. 根据角色类型读取对应的静态json文件获取数据
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        //先判断是否有approver权限
        console.info(approverCustomerList)
        if(approverCustomerList.indexOf(userInfo.requestorID) > -1){
            window.localStorage.setItem('menuList',JSON.stringify(ApproverJson));
            window.location.href='/disputeHome'
        }else{
            //外部用户通过region判断角色
            getUserType()
            .then(res=>{
                const {data,retCode,retMsg} = res;
                let isWE = false, isEM = false;
                if(retCode==='200' && data && data.length){
                    data.forEach((item) => {
                        if(item.region==='WE'){
                            isWE = true;
                        }else if(item.region==='EM'){
                            isEM = true;
                        }
                    })
                    if(isWE){
                        window.localStorage.setItem('menuList',JSON.stringify(WEMenuJson));
                    }
                    if(isEM){
                        window.localStorage.setItem('menuList',JSON.stringify(EMMenuJson));
                    }
                    if(isEM && isWE){
                        window.localStorage.setItem('menuList',JSON.stringify(AllMenuJson));
                    }
                }else{
                    message.error(`${retMsg}`)
                }
                
            }).finally(()=>{
                window.location.href='/disputeHome'
            })
        }
        
    }
    componentDidMount() {
        window.localStorage.setItem('userType','external');
        let webauthn_st = getQueryVariable('webauthn_st');
        let webauthn_realm = getQueryVariable('webauthn_realm');
        window.localStorage.removeItem('userToken');
        window.localStorage.removeItem('lenovoid');
        window.localStorage.removeItem('sst');
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('menuList');
        if(webauthn_st&&webauthn_realm){
            getLenovoIdInfo(webauthn_st, webauthn_realm)
            .then(res=>{
                const {retCode,data}=res;
                if(retCode==='200'){
                    window.localStorage.setItem("userToken", data.userToken)
                    let userInfo = {
                        requestorEmail: data.userName,
                        requestorID: data.userName
                    }
                    window.localStorage.setItem('userId', data.userName);
                    window.localStorage.setItem('lenovoid', data.lenovoid);
                    window.localStorage.setItem('sst', data.sst);
                    localStorage.setItem('userInfo',JSON.stringify(userInfo));
                    this.getMenuList();
                } else{
                    message.warn('Auth failed, please relogin', 1.5)
                    .then(()=>{
                        window.location.href = '/disputeHome'
                    })
                }
            })
        }else{
            message.warn('Auth failed, please relogin', 1.5)
            .then(()=>{
                window.location.href = '/disputeHome'
            })
        }
        
    }
    render() {
        return  <div className="loginSpin">
        <Spin />
      </div>;
    }
}

export default LenovoIdLogin;